import styled, { keyframes } from "styled-components";
import { theme } from "../../../constants/StyledComponents";
import { InputSizes } from "../Input/Input";

const fadeInSlideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledInputOptionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  cursor: pointer;
`;

export const StyledOptionsList = styled.ul`
  position: absolute;
  width: 100%;
  border: 1px solid ${theme.colors.black};
  border-radius: ${theme.variables.border_radius_1};
  background-color: ${theme.colors.white};
  z-index: 1000;
  list-style: none;
  margin-top: 2px;
  padding: 0;
  overflow: hidden;
  animation: ${fadeInSlideDown} 0.1s ease-out;
`;

export const StyledOptionsScrollArea = styled.div`
  max-height: 200px;
  overflow-y: auto;
  padding: 8px 0;
`;

export const StyledSelectContainer = styled.div<{ $size?: InputSizes }>`
  position: relative;
  cursor: pointer;
`;

export const StyledOptionContainer = styled.li`
  padding: 0 8px;
`;

export const StyledOptionItemSelect = styled.div<{
  $selected?: boolean;
  disabled?: boolean;
}>`
  background-color: ${({ $selected: selected }) =>
    selected ? theme.colors.purple : "transparent"};
  padding: 8px;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  border-radius: ${theme.variables.border_radius_1};

  &:hover {
    background-color: ${({ $selected: selected, disabled }) =>
      disabled
        ? "transparent"
        : selected
          ? theme.colors.purple
          : theme.colors.purple_2};
  }
`;
